const updateAnnouncementSliderTabindex = () => {
    const selectedSlide = document.querySelector('.announcement-slider__slide.is-selected');
    if (selectedSlide) {
        selectedSlide.querySelectorAll('a').forEach(a => {
            a.removeAttribute('tabindex');
        });
    }
};

new MutationObserver((mutations) => {
    document.querySelectorAll('span[role="button"]').forEach(el => {
        el.removeAttribute('role')
    });
    mutations.forEach(mutation => {
        if (mutation.target.classList && mutation.target.classList.contains('announcement-slider__slide')) {
            updateAnnouncementSliderTabindex();
        }
    });
}).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

updateAnnouncementSliderTabindex();

document.querySelectorAll('span[role="button"]').forEach(el => {
    el.removeAttribute('role');
    el.removeAttribute('tabindex');
})

new MutationObserver(() => {
    fixAccessibility();
}).observe(document.body, { childList: true, subtree: true });

const fixAccessibility = () => {
    document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    })
}

fixAccessibility();